'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelGroup = exports.Panel = undefined;

var _Panel2 = require('./Panel');

var _Panel3 = _interopRequireDefault(_Panel2);

var _PanelGroup2 = require('./PanelGroup');

var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Panel = _Panel3["default"];
exports.PanelGroup = _PanelGroup3["default"];


//////////////////
// WEBPACK FOOTER
// ./~/bee-panel/build/index.js
// module id = 9
// module chunks = 0